import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import React from 'react';
import { Provider } from 'react-redux';
import AclContextProvider from '../../../Modules/Acl/Components/AclContextProvider';
import DefaultSettingsWrapper from './DefaultSettingsWrapper';

loadDOMComponent({
	selector: 'react-default-settings',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<DefaultSettingsWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
